import React, { useState, useEffect } from 'react';
import { Plug } from 'lucide-react';
import Layout from '../components/layout/Layout.tsx';
import { fetchRestaurant, saveSettings } from '../services/api.ts';

const SischefIntegration = () => {
  const [active, setActive] = useState(false);
  const [token, setToken] = useState('');
  const [isLoading, setIsLoading] = useState(true);
  const [isSaving, setIsSaving] = useState(false);
  const [saveSuccess, setSaveSuccess] = useState(false);

  useEffect(() => {
    const fetchData = async () => {
      try {
        setIsLoading(true);
        const data = await fetchRestaurant();
        setActive(!!data.integration_sischef_active);
        setToken(data.integration_sischef_token || '');
      } catch (error) {
        console.error('Error fetching integration:', error);
      } finally {
        setIsLoading(false);
      }
    };

    fetchData();
  }, []);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();

    try {
      setIsSaving(true);
      await saveSettings({
        integration_sischef_active: active,
        integration_sischef_token: token,
      });
      setSaveSuccess(true);

      setTimeout(() => {
        setSaveSuccess(false);
      }, 3000);
    } catch (error) {
      console.error('Error saving integration:', error);
    } finally {
      setIsSaving(false);
    }
  };

  if (isLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-white">
        <div className="animate-spin rounded-full h-12 w-12 border-4 border-teal-500 border-t-transparent"></div>
      </div>
    );
  }

  return (
    <Layout>
      <div className="min-h-full bg-[#f6f7fb] px-3 py-6 text-slate-900 sm:px-6 lg:px-8">
        <div className="mx-auto w-full max-w-[1400px] space-y-5">
          <div className="mb-1 text-center">
            <h2 className="flex items-center justify-center gap-3 text-2xl font-black text-slate-900">
              <Plug size={28} className="text-[#2f7d72]" />
              Configurar integração Sischef
            </h2>
            <p className="mx-auto mt-3 max-w-3xl text-sm leading-6 text-slate-600">
              Conecte sua loja Sischef para sincronizar pedidos automaticamente com o Atendabot.
            </p>
          </div>

          <form onSubmit={handleSubmit} className="space-y-6 bg-white rounded-2xl border border-slate-200 p-4 shadow-sm sm:p-5">
        <div className="flex items-center">
          <span className="mr-2">Ativar</span>
          <label htmlFor="sischef-active" className="relative cursor-pointer">
            <input
              id="sischef-active"
              type="checkbox"
              className="sr-only"
              checked={active}
              onChange={e => setActive(e.target.checked)}
            />
            <span className={`block w-10 h-6 rounded-full transition-colors duration-300 ${active ? 'bg-[#2f7d72]' : 'bg-gray-300'}`}></span>
            <span className={`absolute left-0 top-0 w-6 h-6 rounded-full bg-white shadow transform transition-transform duration-300 ${active ? 'translate-x-4' : ''}`}></span>
          </label>
        </div>

        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">Token</label>
          <input
            type="text"
            value={token}
            onChange={e => setToken(e.target.value)}
            className="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-1 focus:ring-teal-500 text-sm"
          />
        </div>

        <div className="flex items-center justify-between">
          {saveSuccess && (
            <p className="text-sm text-green-600 flex items-center">
              <svg className="w-4 h-4 mr-1" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
                <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd"></path>
              </svg>
              Configurações salvas com sucesso!
            </p>
          )}
          <button
            type="submit"
            disabled={isSaving}
            className="inline-flex h-10 items-center justify-center gap-2 rounded-lg bg-[#2f7d72] px-4 text-sm font-semibold text-white transition hover:bg-[#27685f] disabled:cursor-not-allowed disabled:opacity-60"
          >
            {isSaving ? (
              <div className="w-5 h-5 rounded-full animate-spin border-2 border-solid border-white border-t-transparent"></div>
            ) : (
              'Salvar'
            )}
          </button>
        </div>
      </form>
        </div>
      </div>
    </Layout>
  );
};

export default SischefIntegration;
